import React from 'react';
var BraveBrowser = function BraveBrowser(props) {
  return /*#__PURE__*/React.createElement("svg", {
    className: props.className,
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188 59"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(3) translate(7,-17)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Head_1_",
    gradientUnits: "userSpaceOnUse",
    x1: "-507.0056",
    y1: "419.2217",
    x2: "-506.0056",
    y2: "419.2217",
    gradientTransform: "matrix(48.7978 0 0 -58.296 24740.7402 24468.0957)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#FF5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.4099",
    stopColor: "#FF5500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.582",
    stopColor: "#FF2000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FF2000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Head",
    fill: "url(#Head_1_)",
    d: "M47.1,14l1.3-3.4c0,0-1.7-1.9-3.8-4s-6.5-0.9-6.5-0.9l-5-5.8h-8.8h-8.8l-5,5.8 c0,0-4.4-1.2-6.5,0.9s-3.8,4-3.8,4L1.7,14L0,19c0,0,5,19.4,5.6,21.8c1.2,4.7,2,6.5,5.2,8.8s9.3,6.5,10.2,7.1 c1,0.6,2.2,1.7,3.3,1.7c1.1,0,2.3-1.1,3.3-1.7c1-0.6,7-4.7,10.2-7.1s4.1-4.2,5.2-8.8c0.6-2.4,5.6-21.8,5.6-21.8L47.1,14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Face",
    fill: "#FFF",
    d: "M24.4,36.3c0.3,0,2.5,0.8,4.2,1.7c1.7,0.9,3,1.5,3.4,1.8c0.4,0.3,0.2,0.7-0.2,1 c-0.4,0.3-5.2,4.1-5.7,4.5c-0.5,0.4-1.2,1.1-1.6,1.1s-1.2-0.7-1.6-1.1c-0.5-0.4-5.3-4.3-5.7-4.5c-0.4-0.3-0.6-0.7-0.2-1 c0.4-0.3,1.6-0.9,3.4-1.8C21.9,37,24.1,36.3,24.4,36.3z M24.4,8.9c0.2,0,1.1,0.1,2.4,0.5c1.5,0.5,3,1.1,3.8,1.1 s6.2-1.1,6.2-1.1s6.4,7.9,6.4,9.6c0,1.7-0.8,2.1-1.6,3c-0.8,0.9-4.4,4.7-4.8,5.2c-0.5,0.5-1.4,1.2-0.8,2.6 c0.6,1.3,1.4,3.1,0.5,4.8c-0.9,1.7-2.5,2.9-3.5,2.7c-1-0.2-3.4-1.5-4.2-2c-0.9-0.6-3.6-2.9-3.6-3.8c0-0.9,2.8-2.5,3.4-2.8 c0.5-0.4,2.9-1.8,3-2.3c0-0.5,0-0.7-0.7-2.1c-0.7-1.4-2-3.2-1.8-4.4c0.2-1.2,2.3-1.8,3.7-2.4c1.5-0.6,4.3-1.6,4.6-1.8 c0.4-0.2,0.3-0.3-0.8-0.4c-1.1-0.1-4.1-0.5-5.5-0.1s-3.7,1-3.9,1.3S26.8,16.9,27,18c0.2,1.1,1.2,6.3,1.3,7.2 c0.1,0.9,0.3,1.5-0.7,1.8c-1,0.2-2.6,0.6-3.2,0.6s-2.2-0.4-3.2-0.6c-1-0.2-0.8-0.8-0.7-1.8c0.1-0.9,1.1-6.1,1.3-7.2 c0.2-1.1,0-1.1-0.2-1.4c-0.2-0.3-2.5-0.9-3.9-1.3c-1.4-0.4-4.4,0-5.5,0.1s-1.2,0.3-0.8,0.4c0.4,0.2,3.2,1.2,4.6,1.8 c1.5,0.6,3.5,1.2,3.7,2.4c0.2,1.2-1.1,3-1.8,4.4c-0.7,1.4-0.7,1.5-0.7,2.1c0,0.5,2.4,1.9,3,2.3c0.5,0.4,3.4,2,3.4,2.8 c0,0.9-2.8,3.2-3.6,3.8c-0.9,0.6-3.2,1.8-4.2,2c-1,0.2-2.6-1-3.5-2.7c-0.9-1.7-0.1-3.5,0.5-4.8c0.6-1.3-0.4-2.1-0.8-2.6 c-0.5-0.5-4-4.3-4.8-5.2c-0.8-0.9-1.6-1.3-1.6-3c0-1.7,6.4-9.6,6.4-9.6s5.4,1.1,6.2,1.1s2.3-0.6,3.8-1.1 C23.3,8.9,24.2,8.9,24.4,8.9L24.4,8.9z"
  })));
};
export default BraveBrowser;